//密码长度验证
export const passwordlength_rules = (rule, value, callback) => {
  if (value.length < 6) callback(new Error("密码不能少于6位"));
  else callback();
};

//手机号格式验证
export const phone_rules = (rule, value, callback) => {
  let reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
  if (!value) {
    return callback(new Error("手机号码不能为空"));
  } else if (!reg.test(value)) {
    return callback(new Error("手机号格式不正确"));
  } else {
    callback();
  }
};

//邮箱格式验证
export const email_rules = (rule, value, callback) => {
  var reg = /^(?:\w+\.?)*\w+@(?:\w+\.)*\w+$/;
  if (!reg.test(value)) {
    return callback(new Error("邮箱格式不正确"));
  } else {
    callback();
  }
};
